import React, { Component } from 'react';
import url from '../../../urlhandler/urlHandlerActions';
import { findIndex } from 'underscore';
import classNames from 'classnames';

export default class ViewChanger extends Component {
  constructor(props) {
    super(props);
  }
  handleChnagedView(view, e) {
    e.preventDefault();
    const values = [];
    values.push(view);
    const index = findIndex(window.searchArray, { key: 'view' });
    if (index !== -1) {
      if (window.searchArray[index].value.toString() === view) {
        return;
      }
    }
    url.push({
      'searchItem': 'view',
      'searchType': 'globalSearch',
      'searchField': 'topListOrGrid',
      values,
    });
  }
  render() {
    const index = findIndex(window.searchArray, { key: 'view' });
    let viewType = null;
    if (index !== -1) {
      viewType = window.searchArray[index].value;
    }
    const viewChangerButtonGrid = classNames({
      'view-change-btn': true,
      'active': viewType === 'grid',
    });
    const viewChangerButtonList = classNames({
      'view-change-btn': true,
      'active': viewType === 'list',
    });
    return (<div className="left-block">
      <button className={viewChangerButtonGrid} onClick={this.handleChnagedView.bind(this, 'grid')}><i className="fa fa-th" aria-hidden="true"></i></button>
      <button className={viewChangerButtonList} onClick={this.handleChnagedView.bind(this, 'list')}><i className="fa fa-bars" aria-hidden="true"></i></button>
    </div>);
  }
}



/** WEBPACK FOOTER **
 ** ./assets/src/frontend/preview/block/bar/viewChanger.js
 **/